import React, { ReactNode } from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";
import HomeIcon from "@material-ui/icons/Home";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    link: {
      display: "flex",
    },
    icon: {
      marginRight: theme.spacing(1),
      width: 20,
      height: 20,
    },
  })
);

function handleClick(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) {
  event.preventDefault();
  console.info("You clicked a breadcrumb.");
}

export interface BreadcrumbsProps {
  parent: {
    title: string;
    icon: ReactNode;
    link: string;
  };
  child: {
    title: string;
  };
}

export default function IconBreadcrumbs(props: BreadcrumbsProps) {
  const classes = useStyles();

  return (
    <Breadcrumbs aria-label="breadcrumb">
      <Link
        color="inherit"
        href="/"
        // onClick={handleClick}
        className={classes.link}
      >
        ときやど
      </Link>
      <Link color="inherit" href={props.parent.link} className={classes.link}>
        {props.parent.title}
      </Link>
      <Typography color="textPrimary" className={classes.link}>
        {props.child.title}
      </Typography>
    </Breadcrumbs>
  );
}
